import React from "react";
import {Modal,Button,PanelGroup,Panel} from "react-bootstrap";
export default class CostImageShow extends React.Component{
  constructor(props){
    super(props);
  }
  render(){
    var {show,src,closeButton, t} = this.props;
  return  (
    <Modal show={show}>
    <Modal.Header closeButton onHide={closeButton}>
      <Modal.Title id="contained-modal-title">{t('costPhoto')}</Modal.Title>
    </Modal.Header>
      <Modal.Body>
        <div style={{textAlign:"center"}}>
          <img src={src} style={{minWidth:"auto",maxWidth:"100%"}}/>
        </div>
      </Modal.Body>
    </Modal>
    )
  }
}
